import type { GameState, PlayerColor } from "@nextgammon/shared";
import { calculatePipCount } from "@nextgammon/shared";
import { TYPOGRAPHY } from "../constants/uiConstants";

interface PipCounterProps {
  gameState: GameState | null;
  playerColor: PlayerColor;
}

/**
 * Component that displays the current pip count for a specific player.
 * The pip count represents the total number of pips needed to bear off all checkers.
 */
export function PipCounter({ gameState, playerColor }: PipCounterProps) {
  if (!gameState) {
    return null;
  }

  const pipCount = calculatePipCount(gameState, playerColor);

  return (
    <div
      className="pip-counter text-xs text-blue-300 ml-0 mt-0"
      style={{ fontSize: `${TYPOGRAPHY.PIP_COUNT_SIZE}px` }}
    >
      <span className="font-semibold">Pips:</span> {pipCount}
    </div>
  );
}
